import { ComprobantesBySVFId } from '../../hooks/Reintegro/Comprobante/useComprobante';
import { SVF } from '../../types/Siniestro/types';
import { ApiResponse, apiRequest } from '../Utils/apiClient';
import { ADD_COMPROBANTE_CLIENTE_FILE, GET_INDICACIONES } from '../Utils/constants';

const postComprobante = async (formData: FormData): Promise<ApiResponse<boolean>> =>
  apiRequest<boolean>('post', ADD_COMPROBANTE_CLIENTE_FILE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const getComprobantes = async (
  url: string,
  vetFormId: number,
): Promise<ApiResponse<ComprobantesBySVFId>> => apiRequest('get', url, { vetFormId });

const getSVFs = async (id: string): Promise<ApiResponse<SVF[]>> =>
  apiRequest('get', GET_INDICACIONES, { id });

export { postComprobante, getComprobantes, getSVFs };
